module.exports = __webpack_public_path__ + "img/button_spin.0f5efe32.png";